export default __webpack_public_path__ + "static/angular-vue-flutter-quale-scegliere-app-personalizzate-3abb7a2dd383cd3eee2ae330ce65fc8f.jpg";